import AbstractApiService from "./AbstractApiService";

export default class ScreenshotService extends AbstractApiService {
    search = (productId: string|null, sceneType: number|null): Promise<any> => {
        const params: Array<string> = [];
        if(productId !== null) {
            params.push('product_id=' + productId);
        }
        if(sceneType !== null) {
            params.push('scene_id=' + sceneType);
        }
        return this.call('GET', `/screenshots?${params.join('&')}`);
    };
}
